import React, { useEffect } from 'react';
import { useProcessingStore } from '../stores/processingStore';

interface AppInitializerProps {
  children: React.ReactNode;
}

export const AppInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  const { checkActiveProcesses } = useProcessingStore();

  useEffect(() => {
    // Check for any active processes when the app loads
    checkActiveProcesses();
  }, [checkActiveProcesses]);

  return <>{children}</>;
};